module.exports = __webpack_public_path__ + "img/tema-3-5.c138e107.svg";